jQuery(function() {
    jQuery(".js-load-more-category-posts").on("click", function(e) {
        e.preventDefault();
        jQuery( this ).prop( "disabled", true );
        //console.log("get data");
        var cat = jQuery(".js-load-more-category-posts").attr('data-cat');
        var featured = jQuery(".js-load-more-category-posts").attr('data-featured');
        var paged = jQuery(".js-load-more-category-posts").attr('data-paged');
        var max_paged = jQuery(".js-load-more-category-posts").attr('data-maxpages');
        var posts_per_page = parseInt(jQuery(this).attr('data-posts-per-page'));
        $.ajax({
            //url: "http://freeway.test/api/knowledge/get-paged-posts.php",
            url: window.location.origin + "/wp-content/themes/southern/load-category-posts-json.php",
            data: "cat=" + cat + "&featured="+featured+"&paged=" + paged+"&posts_per_page=" + posts_per_page,
            type: "GET",
            //dataType: "jsonp", 
            success: function(data) {
                if (data.length > 0) {
                    paged = parseInt(paged) + 1;
                    if (paged > max_paged) {
                        jQuery(".js-load-more-category-posts").hide();
                    }
                    jQuery(".js-load-more-category-posts").attr('data-paged', paged);
                    jQuery("ul.o-list-bare.c-blog-teaser__list li:last").after(data);
                    jQuery(".js-load-more-category-posts").prop( "disabled", false );
                }
                //console.log(data);
                //console.log("get data");

            }
        });
    })
})